import * as React from 'react';
import './src/styles/global.css';
import RootElement from './src/components/root-elemente';

export const wrapPageElement = ({ element }) => {
  return <RootElement>{element}</RootElement>;
};
